import { render } from "./SimilarAnime.vue?vue&type=template&id=03f624d0"
import script from "./SimilarAnime.vue?vue&type=script&lang=js"
export * from "./SimilarAnime.vue?vue&type=script&lang=js"

import "./SimilarAnime.vue?vue&type=style&index=0&id=03f624d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__